import React from 'react';
export function CTABanner() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative py-24 px-4 sm:px-6 lg:px-8" style={{
    backgroundImage: 'url(https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920)',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-78">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50" data-id="element-79" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-80">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-81">
          Ready for a Cleaner Workspace?
        </h2>
        <p className="text-white/80 text-lg mb-8" data-id="element-82">
          Get your free, no-obligation quote today.
        </p>
        <button onClick={() => scrollToSection('contact')} className="bg-[#6BBF3B] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#5aa832] transition-colors" data-id="element-83">
          Get Your Free Quote
        </button>
      </div>
    </section>;
}